var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3778 6.47327L51.4259 13.4033C51.8301 13.5552 52.1143 13.9423 52.1143 14.383V35.143C52.1143 39.9955 49.3553 44.0256 45.6132 47.5633C42.4804 50.532 38.5926 53.2394 34.8043 55.8776C34.0719 56.3877 33.3431 56.8952 32.6243 57.4015C32.2561 57.6663 31.7436 57.6662 31.3755 57.4013C30.6285 56.8738 29.8709 56.3452 29.1095 55.814C25.3486 53.1902 21.4959 50.5024 18.387 47.5634C14.6449 44.0258 11.8857 39.9955 11.8857 35.143V14.3746C11.8857 13.9406 12.1556 13.5469 12.5786 13.3933L31.623 6.47606C31.6634 6.45855 31.7044 6.44499 31.7221 6.43916C31.738 6.43392 31.7523 6.42941 31.7625 6.42624L31.7751 6.42237L31.779 6.42122L31.7802 6.42086L31.8246 6.40765L31.8701 6.40418C32.0179 6.39292 32.1972 6.40098 32.3778 6.47327ZM14.0035 15.1041V35.143C14.0035 39.1844 16.2922 42.6893 19.8442 46.0584C22.7793 48.8247 26.5069 51.4183 30.2429 54.0178C30.8308 54.4269 31.4189 54.8361 32.0042 55.2461C32.6165 54.8168 33.2317 54.3888 33.8463 53.9612C37.5616 51.3763 41.2565 48.8057 44.164 46.0587C47.7162 42.6895 50.005 39.1845 50.005 35.143V15.1041L32.0043 8.57L14.0035 15.1041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.fb467aa59d445c0f60c92f83c39b25c7.svg";
export { ForwardRef as ReactComponent };